import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const AuthCallback = lazy(() => import('../pages/auth/callback'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ReportPage = lazy(() => import('../pages/dashboard/report/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const PrivacyPage = lazy(() => import('../pages/legal/privacy/page'));
const TermsPage = lazy(() => import('../pages/legal/terms/page'));
const ImprintPage = lazy(() => import('../pages/legal/imprint/page'));
const DisclaimerPage = lazy(() => import('../pages/legal/disclaimer/page'));
const TrialPage = lazy(() => import('../pages/trial/page'));
const PlansPage = lazy(() => import('../pages/plans/page'));
const PaymentSuccessPage = lazy(() => import('../pages/payment/success'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallback />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/dashboard/report/:id',
    element: <ReportPage />,
  },
  {
    path: '/trial',
    element: <TrialPage />,
  },
  {
    // Post-OAuth plan selection. Reached by auth/callback when the
    // user has no plan saved yet (Google/Apple signups land here
    // because the trigger creates the row with plan=null).
    path: '/plans',
    element: <PlansPage />,
  },
  {
    // Stripe Checkout success redirect. Polls for the webhook to
    // activate the plan, then routes to /dashboard.
    path: '/payment-success',
    element: <PaymentSuccessPage />,
  },
  {
    // Thin trigger page that calls the create-checkout-session edge
    // function and redirects to Stripe Checkout. Any link in the app
    // can hit /checkout?plan=builder&billing=monthly to start payment.
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/admin',
    element: <Navigate to="/admin/login" replace />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/imprint',
    element: <ImprintPage />,
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
